import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core'
import { map } from 'lodash';

var faLocationOutline = {
  prefix: 'fas',
  iconName: 'location-outline',
  icon: [ 8, 10, [], 'e001', 'M4 5C4.275 5 4.51042 4.90208 4.70625 4.70625C4.90208 4.51042 5 4.275 5 4C5 3.725 4.90208 3.48958 4.70625 3.29375C4.51042 3.09792 4.275 3 4 3C3.725 3 3.48958 3.09792 3.29375 3.29375C3.09792 3.48958 3 3.725 3 4C3 4.275 3.09792 4.51042 3.29375 4.70625C3.48958 4.90208 3.725 5 4 5ZM4 8.675C5.01667 7.74167 5.77083 6.89375 6.2625 6.13125C6.75417 5.36875 7 4.69167 7 4.1C7 3.19167 6.71042 2.44792 6.13125 1.86875C5.55208 1.28958 4.84167 1 4 1C3.15833 1 2.44792 1.28958 1.86875 1.86875C1.28958 2.44792 1 3.19167 1 4.1C1 4.69167 1.24583 5.36875 1.7375 6.13125C2.22917 6.89375 2.98333 7.74167 4 8.675ZM4 10C2.65833 8.85833 1.65625 7.79792 0.99375 6.81875C0.33125 5.83958 0 4.93333 0 4.1C0 2.85 0.402083 1.85417 1.20625 1.1125C2.01042 0.370833 2.94167 0 4 0C5.05833 0 5.98958 0.370833 6.79375 1.1125C7.59792 1.85417 8 2.85 8 4.1C8 4.93333 7.66875 5.83958 7.00625 6.81875C6.34375 7.79792 5.34167 8.85833 4 10Z']
}

var faGrid = {
  prefix: 'fas',
  iconName: 'grid-apps',
  icon: [ 17, 17, [], 'e002', 'M0.93457 4.5H4.93457V0.5H0.93457V4.5ZM6.93457 16.5H10.9346V12.5H6.93457V16.5ZM0.93457 16.5H4.93457V12.5H0.93457V16.5ZM0.93457 10.5H4.93457V6.5H0.93457V10.5ZM6.93457 10.5H10.9346V6.5H6.93457V10.5ZM12.9346 0.5V4.5H16.9346V0.5H12.9346ZM6.93457 4.5H10.9346V0.5H6.93457V4.5ZM12.9346 10.5H16.9346V6.5H12.9346V10.5ZM12.9346 16.5H16.9346V12.5H12.9346V16.5Z']
}


library.add( 
  faLocationOutline,
  faGrid,
)

export const customIcons = [  
  'location-outline',
  'grid-apps',
]

const customIconsDict = map(customIcons, (item) => ({'name': item}))

export const ecityclicIconsList = {
  title: 'ecityclic',
  list: customIconsDict,
};

const CustomIcon = (props) => {
  const { name, size, className } = props;
  const formatedName = name
    .split(' ')
    .map((separetedName) => `fa-${separetedName}`)
    .join(' ');
  return (
    <>
      <FontAwesomeIcon icon={`fa-solid ${formatedName}`} className={`${className ? className : ''} ${size ? size : ''}`} />
    </>
  );
};

export default CustomIcon;